import { render, staticRenderFns } from "./TabDadosUsuario.vue?vue&type=template&id=6018295a&scoped=true&"
import script from "./TabDadosUsuario.vue?vue&type=script&lang=js&"
export * from "./TabDadosUsuario.vue?vue&type=script&lang=js&"
import style0 from "./TabDadosUsuario.vue?vue&type=style&index=0&id=6018295a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6018295a",
  null
  
)

export default component.exports